import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MaskDialog } from '../mask/mask-dailog.component';
import { FeedBackService } from '../services/feedback.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import E from 'wangeditor'
import i18next from 'i18next'
import { getFullUrl } from '../services/util.service';
const unacceptType=['htm', 'html', 'exe']

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  editor: any;
  fileObj = null;
  displayName = [];
  initBugDialogHeight = ''
  scoreClass = 200
  _color=''
  bugInfo = {
    Summary:'',
    Env: '',
    Priority:'Medium',
    ExpResult:'',
    ActResult:''
  }
  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<FeedbackComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fbService : FeedBackService,
    private _snackBar: MatSnackBar
    ) { 

    }

  ngOnInit(): void {
    this.data.category = 'General Feedback'
    this.initBugDialogHeight = document.body.clientHeight < 560 ? '560px' : document.body.clientHeight*0.77+'px'
  }
  ngAfterViewInit():void{
    this.initRichText()
  }
  ngOnDestroy(){
    this.editor.destroy();
    this.editor = null;
  }
  initRichText(){
      this.editor = new E('#editorTest');
      this.editor.config.height = 150
      this.editor.config.zIndex = 1049
      this.editor.i18next = i18next
      this.editor.config.lang = 'en'
      this.editor.config.menus = [
        'head',
        'bold',
        'fontSize',
        'italic',
        'underline',
        'indent',
        'foreColor',
        'backColor',
        'link',
        'list'
    ]
    this.editor.config.menuTooltipPosition = 'down'
    this.editor.config.uploadImgServer = '/upload-img'
      this.editor.config.onchange = (newHtml) => {
        this.data.comments = newHtml;
      };
      this.editor.create();
      this.editor.txt.html(this.data.comments || '');
    
  }
  save():void{
    if(this.data.category === 'Report Bug'){
      if(!this.data.comments || !this.bugInfo.Summary){
         this._snackBar.open('Please fill "Steps to reproduce" and "Summary of Bug" to help the team fix the issue.', '', {
          duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast'
        });
        return
      }
    }else{
      if(this.data.comments==="" && this.data.score===""){
         this._snackBar.open('Please provide comments or score', '', {
          duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast'
        });
        return
      }
    }
    this.openDialog()
    this.sendFeedback()
    //alert(JSON.stringify(this.data))
    //this.dialogRef.close("cancel");
  }
  close(){     
      this.dialogRef.close("cancel");
  }
  uploadFile(){
    this.fileObj = document.getElementById('uploadImageForFB')
    setTimeout(() => {
      this.fileObj.click();
    }, 100);
  }
  changeName(){
    for(let i=0;i<this.fileObj.files.length;i++){
      let temFileName=this.fileObj.files[i].name.split('.')
      if(temFileName.length === 1 || unacceptType.indexOf(temFileName.pop()) !== -1){
        this._snackBar.open('Please upload the files except no type, html and exe files', '', {
          duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast'
        });
        this.displayName.splice(0, this.displayName.length)
        this.fileObj.value=""
        return false
      }
      if(this.fileObj.files[i].size > 3145728){
        this._snackBar.open('Please upload the image file smaller than 3M', '', {
          duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast'
        });
        this.displayName.splice(0, this.displayName.length)
        this.fileObj.value=""
        return false
      }

    }
    this.displayName.splice(0, this.displayName.length)
    for(let i=0;i<this.fileObj.files.length;i++){
      this.displayName.push(this.fileObj.files[i].name);
    }
  }
  openDialog() {
    this.dialog.open(MaskDialog, {
      id:'addGroupMaskD',
      height: '240px',
      width: '250px',
      disableClose: true,
      data: {
        showClose:false,
        message:'Your feedback helps improve DXC Estate Maps',
        marginLeft:'35%',
        fatherID:this.dialogRef.id
      }
    });
  }
   sendFeedback(){
     var url = getFullUrl();
      var formData = new FormData();
      formData.append('category', this.data.category)
      var tempComments=this.data.comments
      var priority = ''
      if(this.data.category==='Report Bug'){
        tempComments = '<p><b>Summary of Bug:</b><br/></p><p>'+this.bugInfo.Summary+'</p><p><b>Your Environment:</b><br/></p><p>'+this.bugInfo.Env+'</p><p><b>Steps to reproduce:</b><br/></p>'+this.data.comments+'<p><b>Expected Result:</b><br/></p><p>'+this.bugInfo.ExpResult+'</p><p><b>Actual Result:</b><br/></p><p>'+this.bugInfo.ActResult+'</p>'
        priority = this.bugInfo.Priority
      }
      formData.append('suggestion', tempComments)
      if(this.fileObj){
        for(let i=0;i<this.fileObj.files.length;i++){
        formData.append(this.fileObj.files[i].name, this.fileObj.files[i])
      }
      }
      
      formData.append('priority', priority)
      formData.append('score', this.data.score)
      formData.append('referer', url)
      formData.append('accountid', location.pathname.includes('landscape') ? (location.search.substring(1) ? location.search.substring(1).split('&')[0].split('=')[1] : ''):'')
       this.fbService.sendFeedback(formData).then(
         (res:any) => { 
           if(res.status && res.status !== 200){
             this.dialog.getDialogById('addGroupMaskD').componentInstance.data.message = "Server Error. Feedback cannot be sent."
           }
          this.dialog.getDialogById('addGroupMaskD').componentInstance.data.showClose = true
         },
         (err) => { alert(err);this.dialog.getDialogById('addGroupMaskD').componentInstance.data.showClose = true}
       )
 
  }
  getScore(){
    if(this.scoreClass == 200){
      return ''
    }
    return Math.ceil(Number(this.scoreClass)/10)
  }
  changeTheDialogSize(){
    if(this.data.category === 'Report Bug'){
      this.dialog.getDialogById('sendFeebbackDl').updateSize('660px', this.initBugDialogHeight)
    }else{
      this.dialog.getDialogById('sendFeebbackDl').updateSize('560px', '560px')
    }
  }
  formatValue(value){
    var self=this
    if(self._color == 'amberSliderColor'){
      return ''
    }else{
      return value
    }
  }
  changeTheScore(){
    this.scoreClass = this.data.score
  }
}
